<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Edit Message</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <router-link to="/admin/messages" class="btn btn-primary" role="button">
                        back
                    </router-link>
                </div>
            </div>
            <form @submit.prevent="updateMessage" v-if="message">
                <div class="row justify-content-md-center">
                  <div class="col-12">
                    <div class="row">
                      <div class="col-md-12">
                        <fg-input type="text"
                                  v-model="message.greeting"
                                  label="Message"
                                  placeholder="Enter Greeting Message"
                                  v-validate="rules.greeting"
                                  data-vv-name="Message"
                                  cus-name="Message"
                                  :has-errors="errors"
                                  :is-fields="fields">
                        </fg-input>
                      </div>
                      <div class="col-12" v-if="corps.length">
                        <multiselect
                          v-model="message.csvCorporationId"
                          placeholder="Select Corporation"
                          :multiple="true"
                          :taggable="true"
                          :options="corps.map(type => type.corporationId)"
                          :custom-label="opt => corps.find(x => x.corporationId == opt).name"
                          required>
                          >
                        </multiselect>
                      </div>
                      <div class="col-3" v-if="status.length">
                        <fg-select
                          v-model="message.active"
                          label="Status"
                          v-validate="rules.active"
                          data-vv-name="active"
                          cus-name="active"
                          :has-errors="errors"
                          :is-fields="fields"
                          :list="status"
                          selectedKey="id"
                        >
                        </fg-select>
                      </div>
                    </div>
                  </div>
                    <div class="col-6 text-center">
                        <button type="submit" :disabled="errors.any()" class="btn btn-primary btn-fill btn-block">
                            Update Message
                        </button>
                    </div>
                </div>
                <div class="clearfix"></div>
            </form>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import { imageHelpers } from '../../../../helpers/lambda'
    import moment from 'moment'
    export default {
      name: 'EditMessage',
      created (){
        this.fetchCorporations();
        this.$store.dispatch('GETSELECTEDMESSAGE', this.$route.params.id).then(() =>{
          this.message = this.selectedMessage;
          this.message.csvCorporationId = this.message.csvCorporationId ? this.message.csvCorporationId.split(',') : 3
          console.log(this.message.csvCorporationId);
        })
      },
    data () {
        let dateTime = new Date();
        return {
          message: this.selectedMessage || {},
          corps: {},
          rules: {
            greeting: {required : true},
            active: {required: true}
          },
          message: {
            error: false,
            text: ''
          },
          status: [{name:'Select Status'}, {id:"1", name:'Active'}, {id:"0", name:'Inactive'}],
        }
    },
    methods: {
      fetchCorporations () {
        this.$store.dispatch('FETCH_CORPORATIONS')
          .then((res) => {
            this.corps = res;
            console.log("this.corporations : ", this.corps);
          })
          .catch(err => {
            console.log("API error : ", err);
          }),
          (err) => {
            console.log("err : ", err);
          }
      },
        updateMessage () {
          this.$validator.validateAll().then((result) => {
            if(result){

              let updateMessage = () =>{
                this.$store.dispatch('UPDATE_MESSAGE', this.message)
                  .then((res) => {
                    console.log("UPDATE_EVENT res : ", res);
                    this.showPopup('Success!', 'Message is successfully updated', 'success', ()=>this.$router.push('/admin/messages'))

                  })
                  .catch(err => {
                    this.showPopup('Error!', 'some thing happen wrong', 'error')
                    console.log("UPDATE_MESSAGE API error : ", err);
                  })
              };
              updateMessage();
            }
          })
        },
        showPopup(title, msg, popupType, cb){
            this.$swal( title, msg, popupType
            ).then(res => {
                        cb && cb();
                        return res
                    })
        }
    },
    computed: {...mapGetters([
        'messages', 'selectedMessage']) }
    }
</script>

<style>
    .form-control{
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Messages/EditMessage.vue